<template>
  <el-dialog
    width="40%"
    :title="title"
    :visible.sync="dialog"
    append-to-body
    @close="cancel"
  >
    <el-row>
      <slot name="tableHead"></slot>
      <!-- 动态表格组件 -->
      <TableCommon
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :tableColumns="tableColumns"
        :tableData="tableData"
        :uniqueNum="uniqueNum"
        :cellStyle="$store.state.cellStyle"
        :headerCellStyle="$store.state.headerCellStyle"
        :reserveSelection="reserveSelection"
        :searchPlaceholder="searchPlaceholder"
        @handleSelection="handleSelection"
        @selectionAll="selectionAll"
        @searchFilter="searchFilter"
        :height="450"
        :rowkey="'rydm'"
      ></TableCommon>
    </el-row>
    <slot name="page"></slot>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancel()" size="small" v-if="cancelBtn">
          <i class="fa fa-close" /> {{ cancelText }}
        </el-button>
        <el-button
          type="primary"
          @click="confirm()"
          size="small"
          v-if="confirmBtn"
        >
          <i class="fa fa-check" />{{ confirmText }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "dialogxmsqry",
  computed: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    tableData: {
      // 表格数据
      type: Array,
    },
    uniqueNum: {
      type: String,
      default: "",
    },
    dialogbsqr: {
      type: Boolean,
      default: false,
    },
    cancelBtn: {
      type: Boolean,
      default: true,
    },
    confirmBtn: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    confirmText: {
      type: String,
      default: "确认",
    },
    searchPlaceholder: {
      type: String,
      default: "请输入关键字",
    },
    reserveSelection: { type: Boolean, default: true },
  },
  watch: {
    dialogbsqr: {
      handler(newVal, oldVal) {
        this.dialog = newVal;
      },
      deep: true, // 开启深度监听
    },
    uniqueNum: {
      handler(newVal, oldVal) {
        let arr = [];
        arr = newVal.split("-");
        this.uniqueNumParams.pageId = arr[0];
        this.uniqueNumParams.moduleId = arr[1];
        this.uniqueNumParams.groupId = arr[2];
        this.getPageTableConfig();
      },
      deep: true, // 开启深度监听
    },
  },
  data() {
    return {
      tabLoading: false,
      tableColumns: [],
      dialog: false,
      ryxx: [],
      uniqueNumParams: {
        pageId: "",
        moduleId: "",
        groupId: "",
      },
      radio: false,
    };
  },
  methods: {
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil
        .getXtTableConfig(this.uniqueNumParams)
        .then((tmpResult) => {
          this.tableColumns = tmpResult;
          this.tableColumns.forEach((item) => {
            if (item.columnKey == "xzk" && item.isSelectedDisable == "1") {
              this.radio = true;
            }
          });
        });
    },
    // 选中表格时方法
    handleSelection(selection, row) {
      let data = [];
      if (this.radio) {
        data.push(row);
      } else {
        data = selection;
      }
      this.ryxx = data;
      this.$emit("handleSelection", data);
    },
    selectionAll(selection) {
      this.ryxx = [];
      let data = [];
      if (!this.radio) {
        this.ryxx = selection;
        data = selection;
      }
      this.$emit("selectionAll", data);
    },
    // 筛选方法
    searchFilter(search) {
      this.$emit("searchFilter", search);
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm", this.ryxx);
    },
  },
  mounted() {
    let arr = [];
    arr = this.uniqueNum.split("-");
    this.uniqueNumParams.pageId = arr[0];
    this.uniqueNumParams.moduleId = arr[1];
    this.uniqueNumParams.groupId = arr[2];
    this.getPageTableConfig();
  },
};
</script>

<style lang="scss" scoped></style>
